class plot_3d {

    constructor() {
        this.modelViewerParameters = $('#flt-model')[0];
        this.set_listeners();
        this.fl_3d = false;
        this.fl_2d = false;
        this.busy_plotting_2d = false;
        this.animate_interval = false;
        this.view_2d = '3d_orthographic';
        this.start_mouse_over_data = false;
        this.locked_on_mp_rod = false;
        this.show_measures = true;
        this.max_dialog_size = 800;
        this.start_animation_on_2d_plot = false;
        this.deviation_text = null;
        this.chosen_gs_length = null;
        this.d = null;
    }

    set_listeners() {
        var self = this;
        if ($('.show_3d_cad').length) {
            $('.show_3d_cad').click(function (event) {
                if (self.fl_3d) {
                    self.fl_3d.empty_scene();
                    self.fl_3d.render();
                }

                var size = Math.min(window.innerWidth, window.innerHeight, self.max_dialog_size);

                var what = $(this).data('what');

                if (what === 'configuration') {
                    const d = new dialog('<div id="container_3d" style="width: 100%; height: 100%;"></div>', size, size);
                    d.open();
                    self.plot_configuration_3d();
                } else {
                    self.product = cf[what];
                    const d = new dialog('<div id="container_3d" style="width: 100%; height: 100%;"></div>', size, size, self.product);
                    d.open();
                    self._dialog_size = { width: size, height: size };
                    self.plot_single(self.product, '3d');
                }
            });
        }

    }
    async plot_from_console (product, view = '3d', size_x = 800, size_y = 800) {
        const d = new dialog('<div id="container_3d" style="width: 100%; height: 100%;"></div>', size_x, size_y, product);
        d.open();
        this._dialog_size = { width: size_x, height: size_y };

        await this.plot_single(product);
    }

    plot_product_page (product, view = '3d', size_x = 500, size_y = 500) {
        this.plot_single(product);
    }

    async plot_configuration_3d(view = '3d') {
        if (!this.fl_3d) {
            this.fl_3d = new fl_three('container_3d', hdr_url);
            await this.fl_3d.init();
        }
        this.fl_3d.set_container();
        this.fl_3d.append_renderer();
        var to_plot = await this.get_configuration_plot_data();

        await this.fl_3d.set_parts([to_plot], view);
    }

    /**
     * Plot the 2D configuration with the given view.
     * @param {string} view - The view of the configuration ('3d_orthographic' by default).
     * @return {Promise} - A promise that resolves once the configuration is plotted.
     */
    async plot_configuration_2d() {
        // prevent adding the elements more than once to the scene when initiating configurator.js
        if (this.busy_plotting_2d) {
            return;
        }
        this.busy_plotting_2d = true;

        if (!this.fl_2d) {
            this.fl_2d = new fl_three('container_2d_three', hdr_url);
            this.apply_2d_container_size();
            this.fl_2d.cam_type = 'orthographic';
            this.fl_2d.show_shadow = false;
            await this.fl_2d.init();
            this.fl_2d.controls.enabled = false;
            this.fl_2d.show_details = false;
            this.fl_2d.set_container();
            this.fl_2d.append_renderer();

            // Mouse events
            this.fl_2d.canvas.addEventListener('mousedown', this.mouse_down.bind(this), false);
            this.fl_2d.canvas.addEventListener('mouseup', this.mouse_up.bind(this), false);
            this.fl_2d.canvas.addEventListener('mousemove', this.mouse_move.bind(this), false);

            // Touch events
            this.fl_2d.canvas.addEventListener('touchstart', this.mouse_down.bind(this), false);
            this.fl_2d.canvas.addEventListener('touchend', this.mouse_up.bind(this), false);
            this.fl_2d.canvas.addEventListener('touchmove', this.mouse_move.bind(this), false);
            // this.fl_2d.canvas.addEventListener('mouseout', this.mouse_up.bind(this), false);
        } else {
            this.apply_2d_container_size();
        }

        // set the lights such that the mounting parts are not overexposed
        this.fl_2d.update_light_distance(cf.gs.slag / 1000 * 0.75);
        this.fl_2d.empty_scene();
        var to_plot = await this.get_configuration_plot_data();
        await this.fl_2d.set_parts([to_plot], this.view_2d);
        this.plot_measures_2d();

        if (cf.gs.type === 'gastrekveer') {
            cf.plot_3d.set_current_stroke(cf.gs.slag / 1000);
            this.fl_2d.re_center();
            cf.plot_3d.set_current_stroke(0);
            cf.plot_3d.plot_measures_2d();
        } else {
            this.fl_2d.re_center();
        }
        if (this.start_animation_on_2d_plot) {
            if (cf.gs.type !== 'gastrekveer') {
                cf.plot_3d.set_current_stroke(0);
            } else {
                cf.plot_3d.set_current_stroke(cf.gs.slag / 1000);
            }
            this.animate();
        }

        this.busy_plotting_2d = false;
    }

    apply_2d_container_size() {
        if (typeof cf !== 'undefined' && cf.plot_container_size && this.fl_2d) {
            this.fl_2d.set_container_size(cf.plot_container_size.width, cf.plot_container_size.height);
        }
    }

    refit_2d_canvas() {
        if (!this.fl_2d || !this.fl_2d.model_group) {
            return;
        }
        this.fl_2d.set_renderer_size();
        this.fl_2d.re_center();
        this.plot_measures_2d();
    }

    set_view_2d(view = '3d') {
        this.view_2d = view;
        this.plot_configuration_2d();
    }

    plot_measures_2d() {
        var views_on = ['3d_orthographic', 'top', 'backside'];
        if (views_on.indexOf(this.view_2d) === -1 || !this.show_measures) {
            return;
        }

        var dist_stroke_y, dist_stroke_z, dist_overall_y, dist_overall_z;
        var width_canvas_m = this.fl_2d.renderer.domElement.width / this.fl_2d.camera.zoom;
        var height_canvas_m = this.fl_2d.renderer.domElement.height / this.fl_2d.camera.zoom;

        // stroke
        if (this.view_2d === "top") {
            dist_stroke_y = -height_canvas_m / 2 * 3 / 5;
            dist_stroke_z = 0;
            dist_overall_y = height_canvas_m / 2 * 3 / 5;
            dist_overall_z = 0;
        } else {
            dist_stroke_y = 0;
            dist_stroke_z = -height_canvas_m / 2 * 4 / 5;
            dist_overall_y = 0;
            dist_overall_z = height_canvas_m / 2 * 4 / 5;
        }

        var fac = 0.9;
        var v_color = '#024284';
        var h_color = '#007EFF';
        var v_linewidth = 1;
        var h_linewidth = 2;
        var start_stroke = 0;
        var end_stroke = -cf.gasspring_set.current_stroke / 1000;
        var dia_cyl_color = "black";
        var dia_rod_color = "#024284";
        if (fd.get().material === "staal" )  {
            dia_cyl_color = 'white';
        }

        var length_overall_text, stroke_text;
        var length_overall = Math.round(cf.gasspring_set.current_stroke + cf.gs.lengte_huis * 1 + cf.mp_cyl.elongationlength * 1 + cf.mp_rod.elongationlength * 1);
        if (cf.gs.type === 'gastrekveer') {
            length_overall += cf.gs.lengte_ventiel * 1;
        } else if (cf.gs.veiligheidspijp * 1) {
            length_overall += cf.gs.veiligheidspijp * 1;
        }
        
        // Add extender length to total measurement if extender is present and being used
        var use_extension = $('#use_extension_checkbox').is(':checked');
        if (cf.ex && cf.ex.elongation && use_extension) {
            length_overall += cf.ex.elongation * 1;
        }

        var non_abs_error = cf.mp_rod.elongationlength * 1 + cf.mp_cyl.elongationlength * 1 + cf.gs.lengte * 1 - gid('gasspring_total_length').value * 1;
        var l_tot_text_diff;
        var chosen_gs_length;

        var huisdia_frontend_looks = cf.gs.huisdia;
        if (huisdia_frontend_looks === '15'){
            huisdia_frontend_looks = 15.6;
        }

        if (gid("units").value === "Imperial") {
            length_overall_text = mm_to_inch(length_overall) + "\"";
            l_tot_text_diff = " (" + (mm_to_inch(non_abs_error) < 0 ? "" : "+") + mm_to_inch(non_abs_error) + "\""+  ")";
            chosen_gs_length = mm_to_inch(gid('gasspring_total_length').value * 1) + "\"";

            var roddia_text = 'Ø' + mm_to_inch(cf.gs.stangdia) + "\"";
            stroke_text = mm_to_inch(Math.round(cf.gasspring_set.current_stroke)) + "\" | " + roddia_text; //+ " \u2033"
            var huisdia_text = 'Ø' + mm_to_inch(huisdia_frontend_looks) + "\"";
        } else {
            var roddia_text = 'Ø' + cf.gs.stangdia + "mm";

            length_overall_text = length_overall + "mm";
            chosen_gs_length = gid('gasspring_total_length').value + "mm";

            l_tot_text_diff =  (non_abs_error < 0 ? "" : "+") + non_abs_error + "mm";

            stroke_text = Math.round(cf.gasspring_set.current_stroke)+ " mm | " + roddia_text; //+ "mm
            var huisdia_text = 'Ø' + huisdia_frontend_looks + "mm";
        }

        if (fd.get().gasspring_total_length * 1) {
            // length_overall_text += l_tot_text_diff; //+ " \u2033"
        }

        this.fl_2d.draw_line(
            new THREE.Vector3(start_stroke, 0, 0),
            new THREE.Vector3(start_stroke, dist_stroke_y, -dist_stroke_z),
            'stroke_vert_left',
            'line',
            v_color,
            v_linewidth
        );

        this.fl_2d.draw_line(
            new THREE.Vector3(end_stroke, 0, 0),
            new THREE.Vector3(end_stroke, dist_stroke_y, -dist_stroke_z),
            'stroke_vert_right',
            'line',
            v_color,
            v_linewidth
        );

        this.fl_2d.draw_line(
            new THREE.Vector3(start_stroke, dist_stroke_y * fac, -dist_stroke_z * fac),
            new THREE.Vector3(end_stroke, dist_stroke_y * fac, -dist_stroke_z * fac),
            'stroke_hor',
            'arrow',
            h_color,
            h_linewidth,
            stroke_text
        );

        this.fl_2d.draw_static_text(
            new THREE.Vector3(cf.gs.lengte_huis / 2 / 1000, 0, 0),
            'dia_cyl',
            'gas_spring',
            huisdia_text,
            dia_cyl_color
        );

        // this.fl_2d.draw_static_text(
        //     new THREE.Vector3((-cf.gs.lengte_huis - cf.gs.stangdia) / 1000, 0, 0),
        //     'dia_rod',
        //     'mp_cyl_1',
        //     roddia_text,
        //     dia_rod_color
        // );

        // overall
        var start_overall = cf.gs.lengte_huis / 1000 + cf.mp_cyl.elongationlength / 1000;
        var end_overall = -cf.gasspring_set.current_stroke / 1000 - cf.mp_rod.elongationlength / 1000;

        if (cf.gs.type === 'gastrekveer') {
            end_overall += -cf.gs.lengte_ventiel / 1000;
        } else if (cf.gs.veiligheidspijp * 1) {
            end_overall += -cf.gs.veiligheidspijp / 1000;
        }
        
        // Add extender length to end position if extender is present and being used
        // The extension is positioned between the gas spring rod and the mounting part
        var use_extension = $('#use_extension_checkbox').is(':checked');
        if (cf.ex && cf.ex.elongation && use_extension) {
			end_overall += -(cf.ex.elongation / 1000);
		}

        this.fl_2d.draw_line(
            new THREE.Vector3(start_overall, 0, 0),
            new THREE.Vector3(start_overall, dist_overall_y, -dist_overall_z),
            'length_vert_left',
            'line',
            v_color,
            v_linewidth
        );

        this.fl_2d.draw_line(
            new THREE.Vector3(start_overall, dist_overall_y * fac, -dist_overall_z * fac),
            new THREE.Vector3(end_overall, dist_overall_y * fac, -dist_overall_z * fac),
            'length_hor',
            'arrow',
            h_color,
            h_linewidth,
            length_overall_text
        );

        this.fl_2d.draw_line(
            new THREE.Vector3(end_overall, 0, 0),
            new THREE.Vector3(end_overall, dist_overall_y, -dist_overall_z),
            'length_vert_right',
            'line',
            v_color,
            v_linewidth
        );
    }

       async get_configuration_plot_data() {
        var to_plot = [];
        var [translate, names] = await this.prepare_gas_spring_for_plot(cf.gs);

        to_plot.push(
            {
                url: cf.gs.glb_array[0],
                pos: [0, 0, 0, 0, 0, 0],
                name: "gas_spring",
                translate: translate,
                names: names,
            }
        );

        cf.gasspring_set.set_current_stroke(cf.gs.slag * 1);

        // plot mounting part cylinder
        if (cf.mp_cyl.hahntype !== 'none') {
            var mp_cyl_x = cf.gs.lengte_huis / 1000;
            // if (cf.gs.veiligheidspijp * 1) {
            //     mp_cyl_x -= cf.gs.veiligheidspijp / 1000;
            // }
            
            // Cylinder mounting parts should not be affected by extender length
            // They stay at the cylinder end
            if (cf.mp_cyl.glb_array.length === 1) {
                // this is a mounting part with bracket / plate / etc.

                // add mounting part 1
                to_plot.push({
                    url: cf.mp_cyl.glb_array[0],
                    pos: [mp_cyl_x, 0, 0, 0, 0, 0].map((value, index) => value + cf.mp_cyl.correction_placement[0][index]),
                    name: "mp_cyl_1",
                    moving: false,
                });
            }

            if (cf.mp_cyl.glb_array.length === 2) {
                // add mounting part 1

                var position1, position2;
                // add bracket / plate / etc.
                if (cf.mp_cyl.type_aanbouwdeel_array[1] === "bevestigingsplaat") {
                    position1 = [mp_cyl_x, 0, 0, Math.PI, 0, 0];
                    position2 = [mp_cyl_x + cf.mp_cyl.elongationlength / 1000, 0, 0, Math.PI, 0, Math.PI];
                } else if (cf.mp_cyl.type_aanbouwdeel_array[1] === "beugel" && cf.mp_cyl.hahntype_array[1].indexOf("BC") === -1) {
                    position1 = [mp_cyl_x, 0, 0, Math.PI, 0, 0];
                    position2 = [mp_cyl_x + cf.mp_cyl.elongationlength / 1000, 0, 0, 0, Math.PI, 0];
                } else {
                    position1 = [mp_cyl_x, 0, 0, 0, 0, 0];
                    position2 = [mp_cyl_x + cf.mp_cyl.elongationlength / 1000, 0, 0, 0, 0, 0]
                }

                position1 = position1.map((value, index) => value + cf.mp_cyl.correction_placement[0][index]);
                position2 = position2.map((value, index) => value + cf.mp_cyl.correction_placement[1][index]);

                to_plot.push({
                    url: cf.mp_cyl.glb_array[0],
                    pos: position1,
                    name: "mp_cyl_1",
                    moving: false,
                });

                to_plot.push({
                    url: cf.mp_cyl.glb_array[1],
                    pos: position2,
                    name: "mp_cyl_2",
                    moving: false,
                });
            }

            if (cf.mp_cyl.glb_array.length >= 3) {
                // this is a mounting part with 3+ parts (e.g., AG57-BC05-AS01)
                // Base position for part 1 (at cylinder end)
                var base_pos_part1_cyl = [mp_cyl_x, 0, 0, 0, 0, 0];

                // add mounting part 1
                var pos_part1_cyl = base_pos_part1_cyl.map((value, index) => value + (cf.mp_cyl.correction_placement[0] ? cf.mp_cyl.correction_placement[0][index] : 0));
                to_plot.push({
                    url: cf.mp_cyl.glb_array[0],
                    pos: pos_part1_cyl,
                    name: "mp_cyl_1",
                    moving: false,
                });

                // add mounting part 2
                // Base position for part 2 should include elongationlength (matching 2-part logic)
                // correction_placement[1] is relative to this base position
                var base_pos_part2_cyl = [mp_cyl_x + cf.mp_cyl.elongationlength / 1000, 0, 0, 0, 0, 0];
                var pos_part2_cyl = base_pos_part2_cyl.map((value, index) => value + (cf.mp_cyl.correction_placement[1] ? cf.mp_cyl.correction_placement[1][index] : 0));
                to_plot.push({
                    url: cf.mp_cyl.glb_array[1],
                    pos: pos_part2_cyl,
                    name: "mp_cyl_2",
                    moving: false,
                });

                // add mounting part 3
                // Part 3 is typically at the same X position as part 2 (if unconfigured) or at a custom position
                // correction_placement[2][0] equals correction_placement[1][0] if unconfigured (same X as part 2)
                // So base position should also be at elongationlength
                var base_pos_part3_cyl = [mp_cyl_x + cf.mp_cyl.elongationlength / 1000, 0, 0, 0, 0, 0];
                var pos_part3_cyl = base_pos_part3_cyl.map((value, index) => value + (cf.mp_cyl.correction_placement[2] ? cf.mp_cyl.correction_placement[2][index] : 0));
                to_plot.push({
                    url: cf.mp_cyl.glb_array[2],
                    pos: pos_part3_cyl,
                    name: "mp_cyl_3",
                    moving: false,
                });

                // Handle additional parts if they exist (4+ parts)
                // They should also be positioned at elongationlength base (same as part 2 and 3)
                for (let i = 3; i < cf.mp_cyl.glb_array.length; i++) {
                    var base_pos_part_i_cyl = [mp_cyl_x + cf.mp_cyl.elongationlength / 1000, 0, 0, 0, 0, 0];
                    var pos_part_i_cyl = base_pos_part_i_cyl.map((value, index) => value + (cf.mp_cyl.correction_placement[i] ? cf.mp_cyl.correction_placement[i][index] : 0));
                    to_plot.push({
                        url: cf.mp_cyl.glb_array[i],
                        pos: pos_part_i_cyl,
                        name: "mp_cyl_" + (i + 1),
                        moving: false,
                    });
                }
            }
        }

        // Calculate rod end position (used for both mounting parts and extenders)
        var rod_end_x = cf.gs.type === 'gasveer' ? -cf.gs.slag / 1000 : -cf.gs.lengte_ventiel / 1000;
        var rod_end_y = 0;
        var rod_end_z = 0;
        if (cf.gs.veiligheidspijp * 1) {
            rod_end_x -= cf.gs.veiligheidspijp / 1000;
            rod_end_y = 0;
            rod_end_z = 2.95 / 1000;
        }

        // plot mounting part rod
        if (cf.mp_rod.hahntype !== 'none') {
            var mp_rod_x = rod_end_x;
            var mp_rod_y = rod_end_y;
            var mp_rod_z = rod_end_z;
            
            // Add extender length to mounting part position if extender is present and being used
            var use_extension = $('#use_extension_checkbox').is(':checked');
            
            if (cf.ex && cf.ex.elongation && use_extension) {
                mp_rod_x += -1 * cf.ex.elongation / 1000;
            }

            if (cf.mp_rod.glb_array.length === 1) {
                // add mounting part 1 (single part only)
                var mp_rod_final_x = mp_rod_x;
                var mp_rod_data = {
                    url: cf.mp_rod.glb_array[0],
                    pos: [mp_rod_final_x, mp_rod_y, mp_rod_z, Math.PI, 0, Math.PI].map((value, index) => value + cf.mp_rod.correction_placement[0][index]),
                    name: "mp_rod_1",
                    moving: true,
                };
                to_plot.push(mp_rod_data);
            }

            if (cf.mp_rod.glb_array.length === 2) {
                // add mounting part 1
                var mp_rod_final_x = mp_rod_x;
                var mp_rod_data = {
                    url: cf.mp_rod.glb_array[0],
                    pos: [mp_rod_final_x, mp_rod_y, mp_rod_z, Math.PI, 0, Math.PI].map((value, index) => value + cf.mp_rod.correction_placement[0][index]),
                    name: "mp_rod_1",
                    moving: true,
                };
                to_plot.push(mp_rod_data);

                // add bracket / plate / etc.
                to_plot.push({
                    url: cf.mp_rod.glb_array[1],
                    pos: [mp_rod_final_x - cf.mp_rod.elongationlength / 1000, 0, 0, Math.PI, 0, Math.PI].map((value, index) => value + cf.mp_rod.correction_placement[1][index]),
                    name: "mp_rod_2",
                    moving: true,
                });
            }

            if (cf.mp_rod.glb_array.length >= 3) {
                // this is a mounting part with 3+ parts (e.g., AG57-BC05-AS01)
                // The last part needs to be rotated the same as 'bevestigingsplaat'
                var last_part_index = cf.mp_rod.glb_array.length - 1;
                console.log("=== 3+ parts rod side mounting part ===");
                console.log("Total parts:", cf.mp_rod.glb_array.length);
                console.log("Last part index:", last_part_index);
                console.log("GLB filenames:", cf.mp_rod.glb_array.map((url, idx) => {
                    var filename = url.split('/').pop();
                    return `Part ${idx + 1} (index ${idx}): ${filename} - ${idx === last_part_index ? 'LAST PART' : ''}`;
                }));
                
                // Base position for part 1 (at rod end, with rotation for rod side)
                var base_pos_part1_rod = [mp_rod_x, mp_rod_y, mp_rod_z, Math.PI, 0, Math.PI];

                // add mounting part 1
                var pos_part1_rod = base_pos_part1_rod.map((value, index) => value + (cf.mp_rod.correction_placement[0] ? cf.mp_rod.correction_placement[0][index] : 0));
                console.log("Part 1 (index 0) - GLB:", cf.mp_rod.glb_array[0].split('/').pop(), "Position:", pos_part1_rod);
                to_plot.push({
                    url: cf.mp_rod.glb_array[0],
                    pos: pos_part1_rod,
                    name: "mp_rod_1",
                    moving: true,
                });

                // add mounting part 2
                // Base position for part 2 should include elongationlength (matching 2-part logic)
                // For rod side, this is in negative X direction: mp_rod_x - elongationlength
                // correction_placement[1] is relative to this base position
                var base_pos_part2_rod = [mp_rod_x - cf.mp_rod.elongationlength / 1000, mp_rod_y, mp_rod_z, Math.PI, 0, Math.PI];
                var pos_part2_rod = base_pos_part2_rod.map((value, index) => value + (cf.mp_rod.correction_placement[1] ? cf.mp_rod.correction_placement[1][index] : 0));
                console.log("Part 2 (index 1) - GLB:", cf.mp_rod.glb_array[1].split('/').pop(), "Position:", pos_part2_rod);
                to_plot.push({
                    url: cf.mp_rod.glb_array[1],
                    pos: pos_part2_rod,
                    name: "mp_rod_2",
                    moving: true,
                });

                // add mounting part 3
                // Part 3 is typically at the same X position as part 2 (if unconfigured) or at a custom position
                // So base position should also be at mp_rod_x - elongationlength
                var is_last_part = (last_part_index === 2);
                console.log("Part 3 (index 2) - GLB:", cf.mp_rod.glb_array[2].split('/').pop(), "Is last part:", is_last_part);
                
                // For the last part, use [0, 0, 0] as base rotation (like cylinder side) instead of [Math.PI, 0, Math.PI]
                // Then apply bevestigingsplaat rotation: [Math.PI, 0, Math.PI]
                var base_rot_x = is_last_part ? 0 : Math.PI;
                var base_rot_y = 0;
                var base_rot_z = is_last_part ? 0 : Math.PI;
                var base_pos_part3_rod = [mp_rod_x - cf.mp_rod.elongationlength / 1000, mp_rod_y, mp_rod_z, base_rot_x, base_rot_y, base_rot_z];
                console.log("Base position part 3:", base_pos_part3_rod);
                console.log("Correction placement [2]:", cf.mp_rod.correction_placement[2]);
                var pos_part3_rod = base_pos_part3_rod.map((value, index) => {
                    // If this is the last part, apply 'bevestigingsplaat' rotation: [Math.PI, 0, Math.PI]
                    if (is_last_part && index >= 3) {
                        var new_value;
                        if (index === 3) {
                            // X rotation: Math.PI
                            new_value = Math.PI;
                            console.log("  Applying rotation - index", index, ":", value, "->", new_value);
                            return new_value;
                        } else if (index === 4) {
                            // Y rotation: 0
                            new_value = 0;
                            console.log("  Applying rotation - index", index, ":", value, "->", new_value);
                            return new_value;
                        } else if (index === 5) {
                            // Z rotation: Math.PI
                            new_value = Math.PI;
                            console.log("  Applying rotation - index", index, ":", value, "->", new_value);
                            return new_value;
                        }
                    }
                    var corrected_value = value + (cf.mp_rod.correction_placement[2] ? cf.mp_rod.correction_placement[2][index] : 0);
                    if (index >= 3) {
                        console.log("  No rotation applied - index", index, ":", value, "+ correction =", corrected_value);
                    }
                    return corrected_value;
                });
                console.log("Final position part 3:", pos_part3_rod);
                var part3_plot_data = {
                    url: cf.mp_rod.glb_array[2],
                    pos: pos_part3_rod,
                    name: "mp_rod_3",
                    moving: true,
                };
                // If this is the last part, apply scale to mirror it (same as cylinder side view)
                if (is_last_part) {
                    part3_plot_data.scale = [1, 1, -1]; // Mirror on Z-axis
                    console.log("  Applying scale to mirror part 3:", part3_plot_data.scale);
                }
                to_plot.push(part3_plot_data);

                // Handle additional parts if they exist (4+ parts)
                // They should also be positioned at mp_rod_x - elongationlength base (same as part 2 and 3)
                for (let i = 3; i < cf.mp_rod.glb_array.length; i++) {
                    var is_part_i_last = (i === last_part_index);
                    console.log(`Part ${i + 1} (index ${i}) - GLB:`, cf.mp_rod.glb_array[i].split('/').pop(), "Is last part:", is_part_i_last);
                    
                    // For the last part, use [0, 0, 0] as base rotation (like cylinder side) instead of [Math.PI, 0, Math.PI]
                    // Then apply bevestigingsplaat rotation: [Math.PI, 0, Math.PI]
                    var base_rot_x_i = is_part_i_last ? 0 : Math.PI;
                    var base_rot_y_i = 0;
                    var base_rot_z_i = is_part_i_last ? 0 : Math.PI;
                    var base_pos_part_i_rod = [mp_rod_x - cf.mp_rod.elongationlength / 1000, mp_rod_y, mp_rod_z, base_rot_x_i, base_rot_y_i, base_rot_z_i];
                    console.log("Base position part", i + 1, ":", base_pos_part_i_rod);
                    console.log("Correction placement [" + i + "]:", cf.mp_rod.correction_placement[i]);
                    var pos_part_i_rod = base_pos_part_i_rod.map((value, index) => {
                        // If this is the last part, apply 'bevestigingsplaat' rotation: [Math.PI, 0, Math.PI]
                        if (is_part_i_last && index >= 3) {
                            var new_value;
                            if (index === 3) {
                                new_value = Math.PI;
                                console.log("  Applying rotation - index", index, ":", value, "->", new_value);
                                return new_value;
                            } else if (index === 4) {
                                new_value = 0;
                                console.log("  Applying rotation - index", index, ":", value, "->", new_value);
                                return new_value;
                            } else if (index === 5) {
                                new_value = Math.PI;
                                console.log("  Applying rotation - index", index, ":", value, "->", new_value);
                                return new_value;
                            }
                        }
                        var corrected_value = value + (cf.mp_rod.correction_placement[i] ? cf.mp_rod.correction_placement[i][index] : 0);
                        if (index >= 3) {
                            console.log("  No rotation applied - index", index, ":", value, "+ correction =", corrected_value);
                        }
                        return corrected_value;
                    });
                    console.log("Final position part", i + 1, ":", pos_part_i_rod);
                    var part_i_plot_data = {
                        url: cf.mp_rod.glb_array[i],
                        pos: pos_part_i_rod,
                        name: "mp_rod_" + (i + 1),
                        moving: true,
                    };
                    // If this is the last part, apply scale to mirror it (same as cylinder side view)
                    if (is_part_i_last) {
                        part_i_plot_data.scale = [1, 1, -1]; // Mirror on Z-axis
                        console.log("  Applying scale to mirror part", i + 1, ":", part_i_plot_data.scale);
                    }
                    to_plot.push(part_i_plot_data);
                }
                console.log("=== End 3+ parts rod side ===");
            }
        }

        // plot extender if present and checkbox is checked
        var use_extension = $('#use_extension_checkbox').is(':checked');
        
        if (cf.ex && cf.ex.glb_array && cf.ex.glb_array.length > 0 && use_extension) {
            // Calculate extender position at the end of the rod
            // If there's a mounting part, the extender goes between the rod and mounting part
            // If there's no mounting part, the extender goes at the end of the rod
            var extender_x = rod_end_x;
            var extender_y = rod_end_y;
            var extender_z = rod_end_z;
            
            // Extender is always positioned at the rod end
            // The mounting part (if present) will be positioned after the extender
            
            // Add the extender GLB file
            var extender_data = {
                url: cf.ex.glb_array[0],
                pos: [extender_x, extender_y, extender_z, Math.PI, 0, Math.PI].map((value, index) => value + (cf.ex.correction_placement ? cf.ex.correction_placement[0][index] : 0)),
                name: "extender",
                moving: true, // Make extender move with the rod
            };

            to_plot.push(extender_data);
        }
        
        return to_plot;
    }

    async plot_single(product, view = '3d') {
        if (!this.fl_3d) {
            this.fl_3d = new fl_three('container_3d', hdr_url);
            await this.fl_3d.init();
        }
        this.fl_3d.set_container();
        this.fl_3d.append_renderer();

        if (this._dialog_size) {
            this.fl_3d.set_container_size(this._dialog_size.width, this._dialog_size.height);
        }

        var to_plot;
        this.fl_3d.set_renderer_size();
        if (this.is_gs_lt_combi_product(product)) {
            // Pre-merged gas spring + locking tube: keep GLB mesh names intact (product image).
            to_plot = [{
                url: product.glb_array[0],
                pos: [0, 0, 0, 0, 0, 0],
                name: product.hahntype || product.combi_type || product.name || 'gs_lt_combi',
                use_full_scene: true,
            }];
            view = view === '3d' ? '3d_gs' : view;
        } else if (this.is_gas_spring_product(product)) {
            var [translate, names] = await this.prepare_gas_spring_for_plot(product);

            to_plot = [{
                url: product.glb_array[0],
                pos: [0, 0, 0, 0, 0, 0],
                name: product.name,
                translate: translate,
                names: names,
            }];

            view = view === '3d' ? '3d_gs' : view;
        } else {
            if (product.glb_array.length === 1) {
                // this is a single mounting part
                to_plot = [{
                    url: product.glb_array[0],
                    pos: [-product.elongationlength / 1000, 0, 0, 0, 0, 0].map((value, index) => value + product.correction_placement[0][index]),
                    name: product.hahntype,
                }];
            }

            if (product.glb_array.length === 2) {
                // this is a mounting part with bracket / plate / etc.
                to_plot = [];

                // add mounting part 1
                to_plot.push({
                    url: product.glb_array[0],
                    pos: [-product.elongationlength / 1000, 0, 0, 0, 0, 0].map((value, index) => value + product.correction_placement[0][index]),
                    name: product.hahntype_array[0],
                });


                // add bracket / plate / etc.
                to_plot.push({
                    url: product.glb_array[1],
                    pos: [0, 0, 0, 0, 0, 0].map((value, index) => value + product.correction_placement[1][index]),
                    name: product.hahntype_array[1],
                });
            }

            if (product.glb_array.length >= 3) {
                // this is a mounting part with 3+ parts (e.g., AG57-BC05-AS01)
                to_plot = [];

                // add mounting part 1
                to_plot.push({
                    url: product.glb_array[0],
                    pos: [-product.elongationlength / 1000, 0, 0, 0, 0, 0].map((value, index) => value + product.correction_placement[0][index]),
                    name: product.hahntype_array ? product.hahntype_array[0] : (product.hahntype + '_1'),
                });

                // add mounting part 2
                to_plot.push({
                    url: product.glb_array[1],
                    pos: [0, 0, 0, 0, 0, 0].map((value, index) => value + (product.correction_placement[1] ? product.correction_placement[1][index] : 0)),
                    name: product.hahntype_array ? product.hahntype_array[1] : (product.hahntype + '_2'),
                });

                // add mounting part 3
                // Part 3 should extend horizontally from part 2, not drop vertically
                // correction_placement[2] already has the correct X position from PHP processing
                to_plot.push({
                    url: product.glb_array[2],
                    pos: [0, 0, 0, 0, 0, 0].map((value, index) => {
                        if (product.correction_placement && product.correction_placement[2]) {
                            return value + product.correction_placement[2][index];
                        }
                        return value;
                    }),
                    name: product.hahntype_array ? product.hahntype_array[2] : (product.hahntype + '_3'),
                });

                // Handle additional parts if they exist
                for (let i = 3; i < product.glb_array.length; i++) {
                    to_plot.push({
                        url: product.glb_array[i],
                        pos: [0, 0, 0, 0, 0, 0].map((value, index) => value + (product.correction_placement[i] ? product.correction_placement[i][index] : 0)),
                        name: product.hahntype_array ? product.hahntype_array[i] : (product.hahntype + '_' + (i + 1)),
                    });
                }
            }
            view = view === '3d' ? '3d_mp' : view;
        }
        await this.fl_3d.set_parts([to_plot], view);
    }

    set_current_stroke(current_stroke) {
        // gas spring
        var current_stroke_limited;
        // current stroke is out of the limits it can be
        current_stroke_limited = Math.min(Math.max(current_stroke, 0), cf.gs.slag / 1000);
        cf.gasspring_set.set_current_stroke(current_stroke_limited * 1000);

        // then stop any animation
        if (current_stroke_limited !== current_stroke) {
            clearInterval(this.animate_interval);
            this.animate_interval = 0;
            this.start_animation_on_2d_plot = false;
            cf.set_configurator_description();
        }


        if (cf.gs.type === "gastrekveer") {
            var x_in = -current_stroke_limited;
        } else {
            var x_in = cf.gs.slag / 1000 - current_stroke_limited;
        }

        var rod_child = this.fl_2d.scene.children[0].getObjectByName('rod');
        var rod_thread_child = this.fl_2d.scene.children[0].getObjectByName('thread_rod');

        rod_child.position.x = rod_child.x_start + x_in;
        rod_child.updateMatrixWorld(true);
        rod_thread_child.position.x = rod_thread_child.x_start + x_in;
        rod_thread_child.updateMatrixWorld(true);

        if (cf.gs.veiligheidspijp * 1) {
            var washer = this.fl_2d.scene.children[0].getObjectByName('washer');
            washer.position.x = washer.x_start + x_in;
            washer.updateMatrixWorld(true);

            var locking_tube = this.fl_2d.scene.children[0].getObjectByName('locking_tube');
            locking_tube.position.x = locking_tube.x_start + x_in;
            locking_tube.updateMatrixWorld(true);
        }

        // mounting part rod
        for (var i = 1; i < this.fl_2d.model_group.children.length; i++) {
            if (this.fl_2d.model_group.children[i].moving) {
                this.fl_2d.model_group.children[i].position.x = this.fl_2d.model_group.children[i].x_start + x_in;
                this.fl_2d.model_group.children[i].updateMatrixWorld(true);
            }
        }
        // end mounting part rod

        this.fl_2d.render();
    }

    /**
     * Normalize product `type` from configurator / admin 3D payload (string or meta array).
     *
     * @param {string|string[]|undefined} type
     * @returns {string}
     */
    normalize_product_type(type) {
        if (Array.isArray(type)) {
            type = type[0];
        }

        return String(type || '').trim();
    }

    async prepare_gas_spring_for_plot(product) {
        const gs = (typeof cf !== 'undefined' && cf.gs) ? cf.gs : (product || {});
        const gs_type = this.normalize_product_type(gs.type);
        const source = product || gs;

        if (gs_type === 'gasdrukveer blokkeerbaar') {
            return [{ x: 0, y: 0, z: 0 }, ['cyl', 'rod', 'thread_rod', 'thread_cyl', 'locking_tube']];
        }

        if (gs.veiligheidspijp * 1 || this.is_gs_lt_combi_product(source)) {
            return [{ x: 0, y: 0, z: 0 }, ['cyl', 'rod', 'thread_rod', 'thread_cyl', 'washer', 'locking_tube']];
        }

        return [{ x: 0, y: 0, z: 0 }, ['cyl', 'rod', 'thread_rod', 'thread_cyl']];
    }

    /**
     * Pre-merged gas spring + locking tube model (G_LT_… or …-LT_… GLB).
     *
     * @param {object} product Configurator / admin 3D product payload.
     * @returns {boolean}
     */
    is_gs_lt_combi_product(product) {
        if (!product) {
            return false;
        }

        const hahntype = String(product.hahntype || '');
        const combiType = String(product.combi_type || '');
        const glb0 = (Array.isArray(product.glb_array) && product.glb_array[0])
            ? String(product.glb_array[0])
            : '';

        return hahntype.indexOf('G_LT') === 0
            || combiType.indexOf('G_LT') === 0
            || /G_LT_/.test(glb0)
            || /-LT_/.test(glb0);
    }

    /**
     * Whether product data represents a gas spring (incl. blockable tension springs).
     *
     * @param {object} product Configurator product payload.
     * @returns {boolean}
     */
    is_gas_spring_product(product) {
        if (!product) {
            return false;
        }

        const type = this.normalize_product_type(product.type);

        if (type === 'gasveer' || type === 'gastrekveer' || type === 'gasdrukveer blokkeerbaar') {
            return true;
        }

        if (product.slag !== undefined && product.slag !== '' && product.stangdia !== undefined && product.stangdia !== '') {
            return true;
        }

        const description = String(product.description || '');

        if (/^(BS|G|Z|GP)-/.test(description)) {
            return true;
        }

        if (Array.isArray(product.glb_array) && product.glb_array[0] && String(product.glb_array[0]).indexOf('/gs/glb/') !== -1) {
            return true;
        }

        return false;
    }

    animate() {
        var new_stroke, d_stroke_frame, speed, fps = 25, frame_speed;
        speed = cf.gs.type === "gastrekveer" ? -0.4 : 0.2; // m/s
        d_stroke_frame = speed / fps;

        clearInterval(this.animate_interval);
        this.animate_interval = setInterval(() => {
            // simulate a damping effect at the end of the stroke of a gas spring
            frame_speed = d_stroke_frame;
            if (cf.gs.type === "gasveer" && (cf.gasspring_set.current_stroke * 1 > (cf.gs.slag * 0.9))) {
                frame_speed = 0.4 * d_stroke_frame;
            }

            new_stroke = cf.gasspring_set.current_stroke / 1000 + frame_speed;
            this.set_current_stroke(new_stroke);
            this.plot_measures_2d();
            this.set_configurator_description();
        }, 1000 / fps);
    }

    mouse_down() {
        // if mouse was not already down:
        if (!this.mouse_is_down && this.fl_2d.mouse_over_data) {
            this.locked_on_mp_rod = this.fl_2d.mouse_over_data.name.includes("thread_rod");
            if (this.locked_on_mp_rod) {
                this.start_mouse_over_data = this.fl_2d.mouse_over_data;
            }
        }

        this.mouse_is_down = true;
    }

    mouse_up() {
        this.start_mouse_over_data = false;
        this.locked_on_mp_rod = false;
        this.animate();
        this.mouse_is_down = false;
    }


    updateDivPosition(id) {
        let divId = 'popup-mp-cad-div-' + id;
        var plot = document.getElementById('plot');
        var target = document.getElementById(divId);
        var plotOffset = plot.getBoundingClientRect();

        // Set the offset of the target div to match the plot div
        if (id === 'cyl') {
            target.style.left = (plotOffset.left + window.scrollX) + 'px';
        } else if (id === 'gs') {
            target.style.left = (plotOffset.left + window.scrollX + (Math.round(plotOffset.width / 3))) + 'px';
        } else {
            target.style.right = (plotOffset.left + window.scrollX) + 'px';
        }
        target.style.top = (plotOffset.top + window.scrollY + 50) + 'px';
    }

    showHideCadDiv(showId) {
        if (showId) {
            this.updateDivPosition(showId);
        }

        const elements = ['cyl', 'gs', 'rod'];
        elements.forEach(id => {
            if (showId !== id && !this.hoverLock[id]) {
        
                $(`#popup-mp-cad-div-${id}`).fadeOut(3000);
            }
        });

        if (showId && !this.hoverLock[showId]) {
            $(`#popup-mp-cad-div-${showId}`).fadeIn(1000);
        }
    }

    mouse_move(event) {

        if (this.fl_2d.mouse_over_data && this.fl_2d.mouse_over_data.name.includes("thread_rod")) {
            if (this.locked_on_mp_rod) {
                this.fl_2d.canvas.style.cursor = 'grabbing';
            } else {
                this.fl_2d.canvas.style.cursor = 'grab';
            }
        } else {
            this.fl_2d.canvas.style.cursor = '';
        }

        // for the moment not showing a popup
        // if (this.fl_2d.hovering_over && !this.locked_on_mp_rod) {
        //
        //     if (this.fl_2d.hovering_over.startsWith('mp_cyl')) {
        //         this.showHideCadDiv('cyl');
        //     } else if(this.fl_2d.hovering_over.startsWith('mp_rod')) {
        //         this.showHideCadDiv('rod');
        //     } else if(this.fl_2d.hovering_over.startsWith('gas_spring')) {
        //         this.showHideCadDiv('gs');
        //     }
        //
        // } else {
        //     this.showHideCadDiv();
        // }

        if (this.locked_on_mp_rod) {
            var d_x = this.fl_2d.mouse_over_data.mouse_x - this.start_mouse_over_data.mouse_x;

            var current_stroke;
            if (cf.gs.type === 'gasveer') {
                current_stroke = cf.gs.slag / 1000 - d_x;
            } else {
                current_stroke = -d_x;
            }
            this.set_current_stroke(current_stroke);
            this.plot_measures_2d();
            this.set_configurator_description();

            // this.showHideCadDiv();
        }
    }

    set_configurator_description() {
        if (fd.get().force === 'none' || (!this.animate_interval && !this.mouse_is_down)) {
            return;
        }

        var title = cf.gasspring_set.moving_out ? texts.uitschuifkrachttekst : texts.inschuifkrachttekst;
        title += cf.gasspring_set.current_force + texts.inclwrijvingtekst1 + cf.gasspring_set.current_friction_force + texts.inclwrijvingtekst2 + " " + (cf.gasspring_set.current_force / 9.81).toFixed(1) + "kg";

        if (fd.get().units === 'Imperial') {
            title += " | " + newton_to_lbs(cf.gasspring_set.current_force) + " lbs.";
        }

        $("#canvas_title").html(title);
    }

    // timeout(ms) {
    //     return new Promise(resolve => setTimeout(resolve, ms))
    // }
}
